import { render, staticRenderFns } from "./Leavemsg.vue?vue&type=template&id=3473ac36&scoped=true"
import script from "./Leavemsg.vue?vue&type=script&lang=js"
export * from "./Leavemsg.vue?vue&type=script&lang=js"
import style0 from "./Leavemsg.vue?vue&type=style&index=0&id=3473ac36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3473ac36",
  null
  
)

export default component.exports